var map = {
	"./Linux00.png": 6553,
	"./Linux01.png": 8768,
	"./Linux02.png": 7566,
	"./Linux03.png": 5350,
	"./Linux04.png": 6886,
	"./Linux05.png": 9951,
	"./Linux06.png": 6968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7017;